import { menuAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/unbound-method
const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(menuAnatomy.keys)

const commonStyle = definePartsStyle({
  button: {
    _focusVisible: {
      borderWidth: '1px',
      boxShadow: 'outline',
    },
    _disabled: {
      opacity: 0.5,
      _active: {},
      cursor: 'not-allowed',
    },
  },
  divider: {
    borderColor: 'product.border.solid',
    mx: -2,
  },
  list: {
    borderColor: 'product.border.solid',
    borderWidth: '1px',
    p: 2,
    boxShadow: '2xl',
  },
  groupTitle: {
    textTransform: 'uppercase',
  },
  item: {
    borderRadius: 'base',
  },
})

/**
 * Entire menu has a new designs applied.
 * Unfortunately, it's not possible to define gutter in this config.
 * See https://www.figma.com/file/uRe1CJ0AoSnNmzlxIW3RcY/%5BPersona-Exploration%5D-LH-Panel-%2B-Global-Nav?type=design&node-id=26-9938&mode=dev
 */
export const Menu = defineMultiStyleConfig({
  defaultProps: {
    size: 'md',
  },
  baseStyle: ({ colorScheme }) => {
    switch (colorScheme) {
      case 'dark':
        return {
          ...commonStyle,
          button: {
            ...commonStyle.button,
            bg: 'product.primary',
            color: 'white',
          },
          list: {
            backgroundColor: 'product.primary',
            color: 'white',
            ...commonStyle.list,
          },
          item: {
            color: 'white',
            bg: 'product.primary',
            _hover: {
              background: 'product.blue.800',
            },
            _focus: {
              _active: {
                background: 'product.primaryActive',
              },
              background: 'product.blue.800',
            },
            _disabled: {
              opacity: 0.5,
            },
            ...commonStyle.item,
          },
        }
      // FAI-10450 REVERT colorScheme things below once bcg/bain have own tenants
      case 'bcg':
        return {
          ...commonStyle,
          button: {
            ...commonStyle.button,
            bg: '#04532D',
            color: 'white',
          },
          list: {
            backgroundColor: '#04532D',
            color: 'white',
            ...commonStyle.list,
          },
          item: {
            color: 'white',
            bg: '#04532D',
            _hover: {
              background: '#034029',
            },
            _focus: {
              _active: {
                background: '#034029',
              },
              background: '#034029',
            },
            _disabled: {
              opacity: 0.5,
            },
            ...commonStyle.item,
          },
        }
      case 'bain':
        return {
          ...commonStyle,
          button: {
            ...commonStyle.button,
            bg: '#BF0404',
            color: 'white',
          },
          list: {
            backgroundColor: '#BF0404',
            color: 'white',
            ...commonStyle.list,
          },
          item: {
            color: 'white',
            bg: '#BF0404',
            _hover: {
              background: '#D21E1E',
            },
            _focus: {
              _active: {
                background: '#D21E1E',
              },
              background: '#D21E1E',
            },
            _disabled: {
              opacity: 0.5,
            },
            ...commonStyle.item,
          },
        }
      default:
        return {
          ...commonStyle,
          button: {
            ...commonStyle.button,
            _active: {
              borderColor: 'product.secondary',
            },
            bg: 'white',
            borderColor: 'product.border.solid',
            borderWidth: '1px',
          },
          item: {
            _hover: {
              background: 'product.gray.50',
            },
            _focus: {
              _active: {
                background: 'product.blue.100',
              },
              background: 'product.gray.50',
            },
            ...commonStyle.item,
          },
        }
    }
  },
  sizes: {
    md: {
      groupTitle: {
        fontSize: 'product.sm',
        mb: 3,
        mt: 1,
        mx: 2,
      },
      list: {
        gap: 0,
      },
      item: {
        fontSize: 'sm',
        px: 2,
        py: 1,
      },
      button: {
        borderRadius: 'base',
        h: 8,
        py: 1.5,
        px: 3,
      },
    },
  },
  variants: {
    lhsNavigation: {
      ...commonStyle,
      groupTitle: {
        ...commonStyle.groupTitle,
        fontSize: 'product.2xs',
        letterSpacing: '0.5px',
        color: 'product.text.dark.bodySubtle',
        marginBottom: 1,
      },
    },
    globalNavigation: {
      ...commonStyle,
      button: {
        ...commonStyle.button,
        _hover: {
          borderColor: 'product.secondary',
        },
        _pressed: {
          borderColor: 'product.secondary',
        },
        _active: {
          borderColor: 'product.secondary',
          bg: 'product.cyan.50',
        },
      },
    },
  },
})
